module.exports = __webpack_public_path__ + "img/042-aruba.89a52a32.svg";